import { OnboardingFormType } from '../models/onboarding.models';

export const OnboardingFormInitialState: OnboardingFormType = {
  fullName: '',
  phone: '',
  id: '',
};
